(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-feedback-form-iframe"]) return;
  try {
    
  window.addEventListener("message", function(event) {
    if (event.data.height) {
      document.getElementById("customer-feedback-form-iframe").style.height = event.data.height + "px"
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping-form-iframe"]) return;
  try {
    
  window.addEventListener("message", function(event) {
    if (event.data.height) {
      document.getElementById("shipping-form-iframe").style.height = event.data.height + "px"
    }
  })

  } catch(e) { console.error(e); }
})();
})();
